<kendo-dialog [minWidth]="900" [width]="900" *ngIf="dialogAddTaskOpened" (close)="cancelAdd()">
  <kendo-dialog-titlebar>
    <h3>{{'NEW-TASK' | translate}}</h3>
  </kendo-dialog-titlebar>
  <form [formGroup]="taskForm" class="k-form" (ngSubmit)="createTask()">
    <div class="row">
      <div class="col-12">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'NAME' | translate}} *
          </span>
          <input id="name" kendoTextBox formControlName="name" maxlength="255" />
          <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="name.invalid && name.touched">
            {{'REQUIRED-NAME' | translate}}
          </div>
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'DESCRIPTION' | translate}}
          </span>
          <textarea id="description" kendoTextArea rows="1" formControlName="description" maxlength="4000"
            class="w-100"></textarea>
        </label>
      </div>
      <div class="col-6">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'NOTE' | translate}}
          </span>
          <textarea id="note" kendoTextArea rows="1" formControlName="note" maxlength="10485760"
            class="w-100"></textarea>
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'OPENED-ON' | translate}} *
          </span>
          <kendo-datepicker [min]="minOpenedOn" [max]="maxOpenedOn" formControlName="openedOn" required>
          </kendo-datepicker>
          <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="openedOn.invalid && openedOn.touched">
            {{'REQUIRED-OPENED-ON' | translate}}
          </div>
        </label>
      </div>
      <div class="col-4">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'DUE-DATE' | translate}}
          </span>
          <kendo-datepicker formControlName="dueDate"></kendo-datepicker>
        </label>
      </div>
      <div class="col-4">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'PRIORITY' | translate}} <span *ngIf="!(listPriorities.length <= 2)">*</span><span class="dark"
              *ngIf="listPriorities.length <= 2">({{listPriorities[0].text |
              uppercase | translate}})</span>
          </span>
          <kendo-switch *ngIf="listPriorities.length <= 2" id="urgentPriority" formControlName="urgentPriority"
            [onLabel]="'YES' | translate" [offLabel]="'NO' | translate" class="ml-2">
          </kendo-switch>
          <kendo-combobox [data]="listPriorities" id="urgentPriority" formControlName="priority" class="form-control"
            *ngIf="listPriorities.length > 2" [textField]="'text'" [valueField]="'id'">
            <ng-template kendoComboBoxItemTemplate let-dataItem>
              <span innerHTML="{{ dataItem.text | uppercase | translate }}">
              </span>
            </ng-template>
          </kendo-combobox>
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col-6" [hidden]="assigneeId !== undefined && assigneeId !== null && !allowAssigneeOverride">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'ASSIGNEE' | translate}} *
          </span>
          <div class="inputWithIcon">
            <kendo-combobox [data]="assigneeUsersFiltered" [textField]="'name'" [valueField]="'username'" class="w-100"
              formControlName="assignee" [filterable]="true" (filterChange)="filterAssigneeUsers($event)"
              (close)="searchTerm=''" [placeholder]="'TYPE-OR-SELECT' | translate" [itemDisabled]="itemDisabled">
              <ng-template kendoComboBoxItemTemplate let-dataItem>
                <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                </span>
              </ng-template>
            </kendo-combobox>
            <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="assignee.invalid && assignee.touched">
              {{'UPDATE-TASK-ASSIGNEE-REQUIRED' | translate}}
            </div>
          </div>
        </label>
      </div>
      <div class="col-6">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'ASSESSMENT' | translate}}
          </span>
          <div>
            <kendo-combobox id="assessment" formControlName="assessment" class="w-100" [valuePrimitive]="false"
              [filterable]="true" (filterChange)="assessmentFilter($event)" (close)="searchTerm=''"
              [itemDisabled]="assessmentItemDisabled" [data]="assessmentsFiltered" [textField]="'name'"
              [valueField]="'id'">
              <ng-template kendoComboBoxItemTemplate let-dataItem>
                <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                </span>
              </ng-template>
            </kendo-combobox>
          </div>
        </label>
      </div>
    </div>
    <div class="row" *ngIf="selectedFiles && selectedFiles.length > 0" style="max-height:115px;overflow: auto;">
      <div class="col-sm-12">
        <div class="row mt-1" *ngFor="let f of selectedFiles">
          <div class="col-sm-11">
            <i class="fas fa-file fa-lg" class="fa {{getFileTypeClass(f.type)}}" title="{{f.name}}"></i>
            {{f.name}}
          </div>
          <div class="col-sm-1 pointer">
            <i class="fas fa-trash-alt fa-lg" title="{{ 'DELETE' | translate }}" (click)="deleteAttachment(f.name)">
            </i>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="attachmentsEnabled">
      <label class="k-form-field">
        <kendo-upload class="d-none" [autoUpload]="false" [multiple]="true" (select)="onFileChanged($event)">
        </kendo-upload>
        <button class="mt-2 ml-3" kendoButton [primary]="true" type="button" (click)="selectAttachment()">
          {{'ADD-DOCUMENT' | translate}}<i class="far fa-plus"></i>
        </button>
      </label>
    </div>
  </form>
  <div>* {{'REQUIRED-FIELDS' | translate}}</div>
  <kendo-dialog-actions>
    <button kendoButton type="button" (click)="cancelAdd()">
      {{ 'CANCEL' | translate}}
    </button>
    <button appPreventClick kendoButton type="button" [disabled]="taskForm.invalid || addingTask"
      (click)="createTask()">
      {{ 'SAVE' | translate}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>